const getters = {
  getScrollTop: (state) => state.scrollTop,
  getLogInfo: (state) => state.logInfo,
  uid: (state) => state.user.uid,
  mgid: (state) => state.user.mgid,
  mainHostId: (state) => state.user.mainHostId,
  joinTid: (state) => state.user.joinTid,
  groupMainInfo: (state) => state.user.groupMainInfo,
  groupPermission: (state) => state.user.groupPermission,
  groupStatus: (state) => state.user.groupStatus,
  modeJoin: (state) => state.user.modeJoin,
  mainRoomStatus: (state) => state.user.mainRoomStatus,
  mainHostName: (state) => state.user.mainHostName,
  mainRoomId: (state) => state.user.mainRoomId,
  locale: (state) => state.user.locale,
};
export default getters;
